import { IsBoolean } from "class-validator";

export class AdminEnableUserResult {
    @IsBoolean()
    success: boolean;
}